module.exports = __webpack_public_path__ + "img/quadril.d759465b.png";